'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderItems = _react2.default.createClass({
    displayName: 'OrderItems',
    render: function render() {
        var _props = this.props,
            order = _props.order,
            showAction = _props.showAction,
            handleClick = _props.handleClick;

        var columns = [{
            title: '详情',
            key: '0',
            render: function render(text, record) {
                var specs = [];
                for (var key in record.specs) {
                    specs.push(_react2.default.createElement(
                        'p',
                        { key: key },
                        key,
                        '\uFF1A',
                        record.specs[key]
                    ));
                }
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('img', { src: record.preview, style: { width: 60, float: 'left', marginRight: 20 } }),
                    _react2.default.createElement(
                        'p',
                        null,
                        '' + record.title
                    ),
                    specs
                );
            }
        }, {
            title: '文件',
            key: '1',
            render: function render(text, record) {
                if (record.work.file) {
                    return _react2.default.createElement(
                        'a',
                        { href: record.work.file.url },
                        record.work.file.name
                    );
                } else {
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            record.work.id
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            '\u5F85\u751F\u6210'
                        )
                    );
                }
            }
        }, {
            title: '单价',
            key: '2',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'span',
                    null,
                    '\uFFE5',
                    record.price
                );
            }
        }, {
            title: '数量',
            key: '3',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'span',
                    null,
                    record.amount
                );
            }
        }, {
            title: '费用',
            key: '4',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'span',
                    null,
                    '\uFFE5',
                    record.fee
                );
            }
        }, {
            title: '状态',
            key: '5',
            render: function render(text, record, index) {
                return {
                    props: {
                        rowSpan: index === 0 ? order.items.length : 0
                    },
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _constants.ORDER_STATUS[order.status]
                        ),
                        showAction ? _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/orders/' + order.id },
                            '\u67E5\u770B\u8BE6\u60C5'
                        ) : null
                    )
                };
            }
        }];
        var header = function header() {
            return _react2.default.createElement(
                'div',
                { className: 'table-row-title' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'dl',
                        null,
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u8BA2\u5355\u7F16\u53F7\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.id
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u521B\u5EFA\u65F6\u95F4\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.created_at
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u4E0B\u5355\u4EBA\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.buyer.name
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u6536\u8D27\u4EBA\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.receiver.name,
                            '\uFF08',
                            order.receiver.mobile,
                            '\uFF09'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'dl',
                        null,
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u5546\u54C1\u8D39\u7528\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.product_fee
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u8FD0\u8D39\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.shipping_fee
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u4F18\u60E0\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.discount_fee
                        ),
                        _react2.default.createElement(
                            'dt',
                            null,
                            '\u5408\u8BA1\uFF1A'
                        ),
                        _react2.default.createElement(
                            'dd',
                            null,
                            order.total_fee
                        )
                    )
                )
            );
        };
        if (order.status === 3) {
            columns.push({
                title: '操作',
                key: '7',
                render: function render(text, record, index) {
                    return {
                        props: {
                            rowSpan: index === 0 ? order.items.length : 0
                        },
                        children: _react2.default.createElement(
                            _button2.default,
                            { onClick: function onClick(e) {
                                    return handleClick(order && order.id);
                                } },
                            '\u751F\u4EA7\u5B8C\u6210'
                        )
                    };
                }
            });
        }

        var tableConfig = {
            columns: columns,
            dataSource: order.items,
            pagination: false,
            bordered: true,
            showHeader: true,
            title: header,
            rowKey: function rowKey(record) {
                return record.order_item_id;
            }
        };

        return _react2.default.createElement(
            'div',
            { id: 'order-items' },
            _react2.default.createElement(_table2.default, tableConfig)
        );
    }
}); /**
     * 订单商品详情表
     */

exports.default = OrderItems;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_items.js
// module id = 1120
// module chunks = 0